import { IBaseAction } from '../../../interfaces/IBaseAction'
export enum Keys {
    LOADINFOS = 'react/common/infos/LOADINFOS',
    LOADINFOS_PENDING = 'react/common/infos/LOADINFOS_PENDING',
    LOADINFOS_FULFILLED = 'react/common/infos/LOADINFOS_FULFILLED',
    LOADINFOS_REJECTED = 'react/common/infos/LOADINFOS_REJECTED',
    
    SAVEINFOS = 'react/common/infos/SAVEINFOS',
    SAVEINFOS_PENDING = 'react/common/infos/SAVEINFOS_PENDING',
    SAVEINFOS_FULFILLED = 'react/common/infos/SAVEINFOS_FULFILLED',
    SAVEINFOS_REJECTED = 'react/common/infos/SAVEINFOS_REJECTED',
    
    DELETEINFOS = 'react/common/infos/DELETEINFOS',
    DELETEINFOS_PENDING = 'react/common/infos/DELETEINFOS_PENDING',
    DELETEINFOS_FULFILLED = 'react/common/infos/DELETEINFOS_FULFILLED',
    DELETEINFOS_REJECTED = 'react/common/infos/DELETEINFOS_REJECTED',

    OTHER_ACTION = 'react/common/infos/__any_other_action__',
}

export type Types = IBaseAction<Keys>;